// @ts-nocheck
import { useEffect, useMemo, useState } from 'react'
import { RewardfulCoupon } from './model'
import { encodeState } from '../views/auth/utils'
import { SignupState } from '../store/models'

export const useRewardful = () => {
  const [rewardfulReady, setRewardfulReady] = useState<boolean>(false)
  const [rewardfulCoupon, setRewardfulCoupon] = useState<RewardfulCoupon | null>(null)
  const [rewardfulReferral, setRewardfulReferral] = useState<string>()

  useEffect(() => {
    try {
      window.rewardful('ready', () => {
        try {
          setRewardfulCoupon(window.Rewardful.coupon)
          setRewardfulReferral(window.Rewardful.referral)
          setRewardfulReady(true)
        } catch (e) {
          console.error(e)
        }
      })
    } catch (e) {
      console.error(e)
    }
  }, [])

  return {
    rewardfulReady,
    rewardfulCoupon,
    rewardfulReferral,
  }
}

export const useRewardfulState = (state: SignupState | null, shouldUrlEncode: boolean = false) => {
  const { rewardfulReady, rewardfulCoupon, rewardfulReferral } = useRewardful()

  return useMemo(() => {
    if (!rewardfulReady) {
      return state ? encodeState(state, shouldUrlEncode) : null
    }
    const fullState = {
      ...(state && state),
      ...(rewardfulReferral && { referral: rewardfulReferral }),
      ...(rewardfulCoupon?.id && { coupon: rewardfulCoupon?.id }),
    }
    return Object.keys(fullState).length ? encodeState(fullState, shouldUrlEncode) : null
  }, [rewardfulReady, state, rewardfulReferral, rewardfulCoupon, shouldUrlEncode])
}
